function ProductShowcase(){
    return (
         <div style={{ background: '#fff' }}>
            <h2 style={{ margin: 0 }}>Produits en vendette</h2>
        </div>
    );
}
export default ProductShowcase